<template>
    <DCard
        padding
    >
        <DTable
            :items="items"
            :fields="[
                {key: 'id', label: __('settings.market_regions.id')},
                {key: 'name', label: __('settings.market_regions.name')},
                {key: 'countries', label: __('settings.market_regions.countries')},
                {key: 'currency_code', label: __('settings.market_regions.currency_code')},
                {key: 'currency_symbol', label: __('settings.market_regions.currency_symbol')},
                {key: 'price_type', label: __('settings.market_regions.price_type')},
                {key: 'minimum_invoice_amount', label: __('settings.market_regions.minimum_invoice_amount')},
                {key: 'price_display_period', label: __('settings.market_regions.price_display_period')},
                {key: 'parent', label: __('settings.market_regions.parent_id')},
                {key: 'bank_account', label: __('settings.market_regions.bank_account_id')},
                {key: 'actions', label: '', sorter: false, filter: false},
            ]"
            hover
            sorter
        >
            <template #currency_symbol="{item}">
                <td>
                    {{ item.currency_symbol ?? '' }}
                </td>
            </template>

            <template #bank_account="{item}">
                <td>
                    {{ item.bank_account ?? '' }}
                </td>
            </template>

            <template #price_type="{item}">
                <td>
                    {{ getPriceTypeLabel(item.price_type) ?? '' }}
                </td>
            </template>

            <template #minimum_invoice_amount="{item}">
                <td>
                    {{ item.minimum_invoice_amount === null ? '' : priceFormat.numberFormatForInput(item.minimum_invoice_amount) }}
                </td>
            </template>

            <template #price_display_period="{item}">
                <td>
                    {{ getPriceDisplayPeriodLabel(item.price_display_period) }}
                </td>
            </template>

            <template #actions="{item}">
                <td>
                    <div
                        v-if="userPermissions.includes('market_region.edit') || userPermissions.includes('market_region.delete')"
                        class="actions"
                    >
                        <DButton
                            v-if="userPermissions.includes('market_region.edit')"
                            :id="`edit_${item.id}`"
                            mini
                            icon="pencil"
                            @click="editMarketRegion(item.id)"
                        />
                        <DButton
                            v-if="userPermissions.includes('market_region.delete')"
                            :id="`btn-delete-${item.id}`"
                            :disabled="item.countries.length === 0 || item.disabled_deletion === true"
                            mini
                            icon="trash-can-outline"
                            color="danger"
                            @click="destroyMarketRegion(item.id)"
                        />
                    </div>
                </td>
            </template>
        </DTable>
        <DPagination
            v-if="marketRegions.last_page >= 1"
            :active-page="marketRegions.current_page"
            :pages="marketRegions.last_page"
            align="center"
            @update:activePage="changePage"
        />

        <DFabs>
            <DFab
                v-if="userPermissions.includes('market_region.create')"
                id="btn-add"
                icon="plus"
                :label="__('settings.market_regions.add')"
                @click="openCreatePage"
            />
        </DFabs>
        <DModal
            v-model:show="showConfirmationModal"
            :title="__('settings.market_regions.modals.destroy_confirmation.title')"
            :message="__('settings.market_regions.modals.destroy_confirmation.message')"
            is-confirm
            is-error
            @close="showConfirmationModal = false"
            @confirm="deleteCallBack"
        />
    </DCard>
</template>

<script setup>
import { route } from '~@/Composables/route'
import { router, usePage } from '@inertiajs/vue3'
import { computed, ref } from 'vue'
import { __ } from '~@/Composables/translation'
import priceFormat from '~@/Composables/priceFormat'

defineProps({
    marketRegions: {
        type: Object,
        default: () => { return {} }
    },
    items: {
        type: Array,
        default: () => { return [] }
    }
})

const userPermissions = computed(() => usePage().props.auth.permissions)
const showConfirmationModal = ref(false)
let deleteCallBack = () => { return {} }

function destroyMarketRegion (id) {
    deleteCallBack = () => {
        router.delete(route('settings.market-regions.destroy', id))
        showConfirmationModal.value = false
    }

    showConfirmationModal.value = true
}

function editMarketRegion (id) {
    router.get(route('settings.market-regions.edit', id))
}

function openCreatePage () {
    router.get(route('settings.market-regions.create'))
}

function changePage (page) {
    const queryParameters = {}

    if (page > 1) {
        queryParameters.page = page
    }

    router.get(route('settings.market-regions.index'), queryParameters)
}

function getPriceTypeLabel (key) {
    return __('customers.contracts.price_overview_table.' + (key === 'gross' ? 'gross' : 'nett'))
}

function getPriceDisplayPeriodLabel (key) {
    return __('settings.market_regions.price_display_period_' + key)
}

</script>

<style lang="scss" scoped>
.actions {
    display: flex;
    grid-gap: 10px;
    justify-content: flex-end;
}
</style>
